export const HangupIcon = ({ className }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" className={className}>
      <path
        d="M7.51112 27.2747L10.8804 24.6035C11.6899 23.9624 12.1543 23.0007 12.1543 21.9797V17.6108C17.2379 15.9606 22.7502 15.9487 27.8457 17.6108L27.8457 22.0034C27.8457 23.0244 28.3101 23.9861 29.1196 24.6272L32.4651 27.2746C33.8104 28.3312 35.7272 28.2244 36.9415 27.0134L39.0012 24.9596C40.3465 23.618 40.3465 21.3861 38.9179 20.1277C28.1196 10.6182 11.8686 10.63 1.08215 20.1277C-0.346513 21.3861 -0.346513 23.6181 0.998808 24.9596L3.05846 27.0135C4.24901 28.2244 6.16579 28.3313 7.51112 27.2747Z"
        fill="white"
      />
    </svg>
  )
}
